import { selectAppDomain, useAppSelector } from '@ibk/shared-config';
import { AppDomain } from '@ibk/shared-types';
import { useGetAccountantEmissorBusinessDaysQuery, useGetClientEmissorBusinessDaysQuery, } from '../services/contractBeneficiariesApi';
export function useEmissorBusinessDays({ competence, skip = false, }) {
    const appDomain = useAppSelector(selectAppDomain);
    const isAccountant = appDomain === AppDomain.ESCRITORIO;
    const queryArg = { competence };
    const accountantQuery = useGetAccountantEmissorBusinessDaysQuery(queryArg, {
        skip: skip || !isAccountant,
    });
    const clientQuery = useGetClientEmissorBusinessDaysQuery(queryArg, {
        skip: skip || isAccountant,
    });
    const activeQuery = isAccountant ? accountantQuery : clientQuery;
    return {
        businessDays: activeQuery.data ?? 0,
        isLoading: activeQuery.isLoading,
        isError: activeQuery.isError,
    };
}
